// // import React from 'react';
// // import { styled, useTheme } from '@mui/material/styles';
// // import Box from '@mui/material/Box';
// // import MuiDrawer from '@mui/material/Drawer';
// // import MuiAppBar from '@mui/material/AppBar';
// // import Toolbar from '@mui/material/Toolbar';
// // import List from '@mui/material/List';
// // import CssBaseline from '@mui/material/CssBaseline';
// // import Typography from '@mui/material/Typography';
// // import Divider from '@mui/material/Divider';
// // import IconButton from '@mui/material/IconButton';
// // import InboxIcon from '@mui/icons-material/MoveToInbox';
// // import MailIcon from '@mui/icons-material/Mail';
// // import ListItem from '@mui/material/ListItem';
// // import ListItemButton from '@mui/material/ListItemButton';
// // import ListItemIcon from '@mui/material/ListItemIcon';
// // import ListItemText from '@mui/material/ListItemText';
// // import MenuIcon from '@mui/icons-material/Menu';
// // import useMediaQuery from '@mui/material/useMediaQuery';
// // import { Grid } from '@mui/material';
// // import { Outlet, Link } from 'react-router-dom';
// // import Avatar from '@mui/material/Avatar';
// // import CustomUserAppBar from '../AppBar/CustomUserAppBar';

// // export default function WebsiteSideNav() {
// //     const theme = useTheme();
// //     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

// //     const drawerWidth = isMobile ? 60 : 240;

// //     const Drawer = styled(MuiDrawer)(() => ({
// //         width: drawerWidth,
// //         flexShrink: 0,
// //         '& .MuiDrawer-paper': {
// //             width: drawerWidth,
// //             boxSizing: 'border-box',
// //         },
// //     }));

// //     const AppBar = styled(MuiAppBar)(() => ({
// //         zIndex: theme.zIndex.drawer + 1,
// //         backgroundColor: '#1976d2',
// //     }));

// //     const Main = styled('main')(({ theme }) => ({
// //         flexGrow: 1,
// //         padding: theme.spacing(3),
// //     }));

// //     const menuItems = [
// //         { text: 'Feed', path: 'dashboard' },
// //         { text: 'Create Event', path: 'create-event' },
// //         { text: 'Profile', path: 'profile' }
// //     ];

// //     return (
// //         <Box sx={{ display: 'flex' }}>
// //             <CssBaseline />

// //             {/* App Bar */}
// //             <AppBar position="fixed">

// //                 <CustomUserAppBar />
// //             </AppBar>




// //             {/* Sidebar */}

// //             <Drawer variant="permanent">

// //                 <List>
// //                     <Box sx={{
// //                         display: "flex",
// //                         alignItems: "center",
// //                         marginLeft: {
// //                             xs: 0,
// //                             sm: "19px",
// //                             md: "19px"

// //                         },
// //                         marginRight: {
// //                             xs: 0,
// //                             sm: "14px",
// //                             md: "14px"

// //                         },
// //                         padding: "10px",
// //                         // Apply boxShadow only on screen sizes 'sm' and up (not on mobile)
// //                         boxShadow: {
// //                             xs: 0, // mobile view
// //                             sm: 4, // tablet and above
// //                         },
// //                         borderRadius: "10px"
// //                     }}>
// //                         <Box mr={2}>
// //                             <Avatar sx={{ bgcolor: "green" }}>u</Avatar>
// //                         </Box>

// //                         <Box>
// //                             <Typography>Preethi Sagar</Typography>
// //                             <Typography>@preethi</Typography>
// //                         </Box>

// //                     </Box>
// //                     {menuItems.map((item, index) => (
// //                         <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
// //                             <ListItemButton
// //                                 component={Link}
// //                                 to={`/website/${item.path}`}
// //                                 sx={{
// //                                     minHeight: 48,
// //                                     justifyContent: isMobile ? 'center' : 'initial',
// //                                     px: 2.5,
// //                                 }}
// //                             >
// //                                 <ListItemIcon
// //                                     sx={{
// //                                         minWidth: 0,
// //                                         mr: isMobile ? 0 : 3,
// //                                         justifyContent: 'center',
// //                                     }}
// //                                 >
// //                                     {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
// //                                 </ListItemIcon>
// //                                 {!isMobile && <ListItemText primary={item.text} />}
// //                             </ListItemButton>
// //                         </ListItem>
// //                     ))}

// //                 </List>
// //             </Drawer>

// //             {/* Main Content */}
// //             <Grid
// //                 container
// //                 sx={{
// //                     width: "100%",
// //                 }} >
// //                 {/* Main contant div or gird  */}
// //                 <Grid
// //                     item

// //                     size={{ md: 9, xs: 12, sm: 12 }}
// //                     sx={{
// //                         height: { md: "100vh", xs: "90vh", sm: "90vh" }, // take full viewport height
// //                         overflowY: 'auto',  // enable vertical scroll when needed
// //                         width: '100%',      // full width
// //                         boxSizing: 'border-box',
// //                         padding: '16px',     // optional padding
// //                         // border: "1px solid red"
// //                         borderRight: "1px solid rgba(0, 0, 0, 0.12)"


// //                     }}>
// //                     {/* Main contant  */}
// //                     <Outlet />
// //                 </Grid>


// //                 <Grid item

// //                     size={{ md: 3, xs: 12, sm: 12 }}
// //                     sx={{ p: 2 }}>
// //                     <Typography variant="h6" gutterBottom>
// //                         Post Your Event
// //                     </Typography>
// //                     {/* You can place your event form or content here */}
// //                     <Typography>
// //                         📅 Add details about your upcoming event.
// //                     </Typography>
// //                     <Typography variant="h6" gutterBottom>
// //                         Post Your Event
// //                     </Typography>
// //                     {/* You can place your event form or content here */}

// //                 </Grid>

// //             </Grid>

// //         </Box>
// //     );
// // }


// import React, { useEffect, useState } from 'react';
// import { styled, useTheme } from '@mui/material/styles';
// import {
//     Box,
//     CssBaseline,
//     Drawer as MuiDrawer,
//     AppBar as MuiAppBar,
//     Toolbar,
//     List,
//     Typography,
//     IconButton,
//     ListItem,
//     ListItemButton,
//     ListItemIcon,
//     ListItemText,
//     Avatar,
//     Grid,
//     useMediaQuery,
//     Divider,
//     Icon
// } from '@mui/material';
// import MenuIcon from '@mui/icons-material/Menu';
// import InboxIcon from '@mui/icons-material/MoveToInbox';
// import MailIcon from '@mui/icons-material/Mail';
// import { Outlet, Link } from 'react-router-dom';
// // import CustomUserAppBar from '../AppBar/CustomUserAppBar';
// import { StarBorderOutlined } from '@mui/icons-material';
// import CustomUserAppBar from '../AppBar/CustomUserAppBar';
// import SidebarUserList from '../../Pages/Website/HomeProfile/SidebarUserList';
// import { useDispatch, useSelector } from 'react-redux';
// import actions from '../../ReduxStore/actions';
// import { BsFillPostcardHeartFill } from 'react-icons/bs';
// import { IoGitPullRequestSharp } from 'react-icons/io5';
// import { TbUsers, TbUsersPlus } from 'react-icons/tb';
// import { adminUrl } from '../../constants';
// // import SidebarUserList from '../../../Pages/Connection/SidebarUserList';
// // import PostBox from '../../Pages/HomeProfile/PostBox';


// export default function WebsiteSideNav() {
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//     const drawerWidth = isMobile ? 60 : 240;

//     // Styled Drawer
//     const Drawer = styled(MuiDrawer)(() => ({
//         width: drawerWidth,
//         flexShrink: 0,
//         whiteSpace: 'nowrap',
//         '& .MuiDrawer-paper': {
//             width: drawerWidth,
//             boxSizing: 'border-box',
//             position: 'relative', // So AppBar can be on top
//             zIndex: theme.zIndex.appBar - 1,
//         },
//     }));

//     // Styled AppBar
//     const AppBar = styled(MuiAppBar)(() => ({
//         zIndex: theme.zIndex.drawer + 1,
//         backgroundColor: '#1976d2',
//         width: '100%', // Full width to overlap Drawer
//     }));

//     const menuItems = [
//         { text: 'Feed', path: 'user', icon: BsFillPostcardHeartFill },
//         { text: 'Requests', path: 'user/Connections', icon: IoGitPullRequestSharp },
//         { text: 'Suggestion-Friends', path: 'user/suggestionconnections', icon: TbUsersPlus },
//         { text: 'My Connections', path: 'user/myconnections', icon: TbUsers },




//         // { text: 'Watch Videos', path: 'watchvideos' },
//         // { text: 'Photos', path: 'photos' },
//         // { text: 'Files', path: 'files' }

//     ];
//     // const skills = ["HTML", "CSS", "Javascript", "React js"]
//     const [skills, setSkills] = useState([])
//     const { updateUserStoreInfo } = useSelector(state => state?.updateUserStoreInfo);
//     const sessionUserId = sessionStorage.getItem("userId")

//     useEffect(() => {


//         const fetchData = async () => {
//             const data1 = {
//                 data: {},
//                 method: "get",
//                 apiName: `getUserSkills/${sessionUserId}`,
//             };
//             const response = await dispatch(actions.GETUSERSKILLS(data1));

//             console.log(response, "responseresponse")

//             if (response?.payload?.message === "getUserSkills fetched successfully.") {
//                 console.log("hiiiiiiiiiiiiiiii")

//                 // const responseData = response?.payload?.data?.map((data) => ({
//                 //     // user_id: data?.user_id,

//                 //      data,






//                 // }))
//                 setSkills(response?.payload?.data)

//             }
//         }
//         fetchData()


//     }, [updateUserStoreInfo])


//     const dispatch = useDispatch()



//     // const { AlumniSkillsGetById } = useSelector(
//     //     (state) => state?.AlumniSkillsGetById
//     // );

//     // const { websitehomepageGetByToken } = useSelector(
//     //     (state) => state?.websitehomepageGetByToken
//     // );


//     // useEffect(() => {
//     //     const fetchData = async () => {

//     //         const data2 = {
//     //             data: {},
//     //             method: "get",
//     //             apiName: `websitehomepage`,
//     //         };

//     //         const responseDataSkills = await dispatch(actions.WEBSITEHOMEPAGEGETBYTOKEN(data2));
//     //         console.log(responseDataSkills, "responseDataaa")


//     //     }

//     //     fetchData();

//     // }, []);

//     // const skills1 = websitehomepageGetByToken?.data?.skills?.map((skill) => skill?.skill);
//     const { getUserById } = useSelector(state => state?.getUserById);


//     // const sessionUserId = sessionStorage.getItem("userId")

//     // // const dispatch = useDispatch()
//     // useEffect(() => {

//     //     const fetchData = async () => {
//     //         const data1 = {
//     //             data: {},
//     //             method: "get",
//     //             apiName: `getUserById/${sessionUserId}`,
//     //         };
//     //         const response = await dispatch(actions.GETUSERBYID(data1));


//     //     }
//     //     fetchData()


//     // }, [])



//     return (
//         <Box sx={{ background: "var(--main-contentbackgroundcolor)" }}>
//             {/* <CustomUserAppBar /> */}

//             <Box sx={{
//                 display: 'flex', height: 'fit-content', position: "relative",
//                 background: "var(--main-contentbackgroundcolor)",
//             }}>
//                 <CssBaseline />


//                 <Drawer variant="permanent"
//                     // sx={{
//                     // width: "300px",
//                     //     position:"relative",
//                     //     width: { md: "300px", xs: "none" },
//                     //     height: "fit-content",


//                     //     "& .MuiDrawer-paper": {
//                     //         width: { md: "300px", xs: "none" },
//                     //         // height: "auto"
//                     //         height: "fit-content",
//                     //         position: 'relative',
//                     //     }
//                     // }}
//                     // variant="permanent"
//                     sx={{
//                         position: 'relative',
//                         width: { md: '250px', xs: 'none' },
//                         height: '300px', // change to auto
//                         // background:"blue",
//                         background: "var(--main-contentbackgroundcolor)",
//                         // boxShadow: 4,

//                         mt: 3,
//                         ml: 2,
//                         '& .MuiDrawer-paper': {
//                             width: { md: '250px', xs: 'none' },
//                             height: 'auto', // change to auto
//                             position: 'relative',
//                             // background: "red",
//                             // mt: 5
//                             boxShadow: 4
//                         },
//                     }}
//                 >
//                     {/* <Toolbar />  */}
//                     {/* Add space so content starts below AppBar */}
//                     <List
//                         sx={{
//                             // width: "400px",
//                             // background: "var(--main-contentbackgroundcolor)"

//                         }}
//                     >
//                         {/* User Info */}
//                         <Box sx={{
//                             display: "flex",
//                             alignItems: "center",
//                             mx: isMobile ? 0 : 2,
//                             my: 2,
//                             p: 1,
//                             boxShadow: { xs: 0, sm: 2 },
//                             borderRadius: "10px"
//                         }}>
//                             <Avatar sx={{ bgcolor: "green", mr: 2 }} src={`${adminUrl}${getUserById?.data?.profileImage}`}></Avatar>
//                             {!isMobile && (
//                                 <Box>
//                                     <Typography variant="subtitle2">
//                                         {getUserById?.data?.first_name} {getUserById?.data?.last_name}
//                                         {/* {`${websitehomepageGetByToken?.data?.user?.first_name} ${websitehomepageGetByToken?.data?.user?.last_name}`} */}
//                                     </Typography>

//                                     <Typography variant="caption">@{getUserById?.data?.first_name}</Typography>
//                                 </Box>
//                             )}
//                         </Box>

//                         {/* Menu Items */}
//                         {menuItems.map((item, index) => (
//                             <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
//                                 <ListItemButton
//                                     component={Link}
//                                     to={`/${item.path}`}
//                                     sx={{
//                                         minHeight: 48,
//                                         justifyContent: isMobile ? 'center' : 'initial',
//                                         px: 2.5,
//                                     }}
//                                 >
//                                     <ListItemIcon
//                                         sx={{
//                                             minWidth: 0,
//                                             mr: isMobile ? 0 : 3,
//                                             justifyContent: 'center',
//                                         }}
//                                     >
//                                         {/* {index % 2 === 0 ? <InboxIcon /> : <MailIcon />} */}
//                                         <item.icon style={{ fontSize: "18px", color: "black" }} />
//                                     </ListItemIcon>
//                                     {!isMobile && <ListItemText primary={item.text}
//                                         sx={{
//                                             "& .MuiListItemText-primary": {
//                                                 color: "black",
//                                                 fontSize: "16px",
//                                                 fontWeight: "400"
//                                             },
//                                             color: "black"
//                                         }} />}
//                                 </ListItemButton>
//                             </ListItem>
//                         ))}
//                     </List>
//                     {/* <Box sx={{ display: { md: "block", xs: "none" } }}>
//                         <Box sx={{ textAlign: "center" }}>
//                             <Typography variant='subtitle2' sx={{ fontSize: "18px", color: "gray" }}>Profile Views</Typography>
//                             <Box sx={{ display: "flex", justifyContent: "center" }}>
//                                 <Box mr={2}>
//                                     <Typography variant='h4'
//                                         sx={{
//                                             fontSize: "35px",
//                                             color: "var(--main-color)"
//                                         }}>
//                                         08</Typography>
//                                     <Typography variant='body1' sx={{ fontSize: "12px", color: "gray" }}>Last 5 days</Typography>
//                                 </Box>
//                                 <Divider color="var(--main-color)" width='1px' />
//                                 <Box ml={2}>
//                                     <Typography variant='h4' sx={{ fontSize: "35px", color: "var(--main-color)" }}>+43%</Typography>
//                                     <Typography variant='body1' sx={{ fontSize: "12px", color: "gray" }}>Since Last Week</Typography>
//                                 </Box>
//                             </Box>
//                         </Box>
//                     </Box> */}
//                     <Divider />
//                     <Box sx={{ background: "var(--main-contentbackgroundcolor)" }}>
//                     </Box>


//                     <Box sx={{
//                         display: { md: "block", xs: "none" }, mt: 2,
//                         minHeight: "50vh"
//                     }}>

//                         <List
//                             sx={{
//                                 padding: 2

//                             }}
//                         >


//                             {/* Menu Items */}
//                             <Typography variant="h4" sx={{ fontSize: "18px", color: "black", fontWeight: "800" }}>
//                                 Skills:
//                             </Typography>
//                             {skills?.data?.length > 0 ? (
//                                 <>

//                                     {skills?.map((item, index) => (
//                                         <ListItem key={item} disablePadding sx={{ display: 'block' }}>
//                                             <ListItemButton
//                                                 component={Link}
//                                                 // to={`/${item.path}`}
//                                                 sx={{
//                                                     minHeight: 48,
//                                                     justifyContent: isMobile ? 'center' : 'initial',
//                                                     px: 2.5,
//                                                 }}
//                                             >
//                                                 <ListItemIcon
//                                                     sx={{
//                                                         minWidth: 0,
//                                                         mr: isMobile ? 0 : 3,
//                                                         justifyContent: 'center',
//                                                     }}
//                                                 >
//                                                     <StarBorderOutlined />
//                                                 </ListItemIcon>
//                                                 {!isMobile && <ListItemText primary={item}
//                                                     sx={{
//                                                         "& .MuiListItemText-primary": {
//                                                             color: "black",
//                                                             fontSize: "15px",
//                                                             fontWeight: "400"
//                                                         },
//                                                         color: "black"
//                                                     }} />}

//                                             </ListItemButton>
//                                         </ListItem>
//                                     ))}

//                                 </>
//                             ) : (
//                                 <Box
//                                     sx={{
//                                         display: 'flex',
//                                         justifyContent: 'center',
//                                         alignItems: 'center',
//                                         minHeight: '40vh', // or adjust as needed
//                                         width: '100%',
//                                     }}
//                                 >
//                                     <Typography variant='body1'>
//                                         No skills post yet!
//                                     </Typography>
//                                 </Box>
//                             )}
//                         </List>
//                     </Box>
//                 </Drawer>

//                 {/* Main content */}
//                 <Box component="main" sx={{
//                     flexGrow: 1, p: 3,
//                     // width: `calc(100% - ${drawerWidth}px)`,
//                     width: "100px",
//                     //  background: "#f4f2ee" //linked in color
//                     background: "var(--main-contentbackgroundcolor)",
//                     minHeight: "100vh"

//                 }}>
//                     {/* <Toolbar /> */}
//                     {/* Push content below AppBar */}
//                     <Outlet />
//                 </Box>
//             </Box >
//         </Box >
//     );
// }


// import React from 'react';
// import { styled, useTheme } from '@mui/material/styles';
// import Box from '@mui/material/Box';
// import MuiDrawer from '@mui/material/Drawer';
// import MuiAppBar from '@mui/material/AppBar';
// import Toolbar from '@mui/material/Toolbar';
// import List from '@mui/material/List';
// import CssBaseline from '@mui/material/CssBaseline';
// import Typography from '@mui/material/Typography';
// import Divider from '@mui/material/Divider';
// import IconButton from '@mui/material/IconButton';
// import InboxIcon from '@mui/icons-material/MoveToInbox';
// import MailIcon from '@mui/icons-material/Mail';
// import ListItem from '@mui/material/ListItem';
// import ListItemButton from '@mui/material/ListItemButton';
// import ListItemIcon from '@mui/material/ListItemIcon';
// import ListItemText from '@mui/material/ListItemText';
// import MenuIcon from '@mui/icons-material/Menu';
// import useMediaQuery from '@mui/material/useMediaQuery';
// import { Grid } from '@mui/material';
// import { Outlet, Link } from 'react-router-dom';
// import Avatar from '@mui/material/Avatar';
// import CustomUserAppBar from '../AppBar/CustomUserAppBar';

// export default function WebsiteSideNav() {
//     const theme = useTheme();
//     const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

//     const drawerWidth = isMobile ? 60 : 240;

//     const Drawer = styled(MuiDrawer)(() => ({
//         width: drawerWidth,
//         flexShrink: 0,
//         '& .MuiDrawer-paper': {
//             width: drawerWidth,
//             boxSizing: 'border-box',
//         },
//     }));

//     const AppBar = styled(MuiAppBar)(() => ({
//         zIndex: theme.zIndex.drawer + 1,
//         backgroundColor: '#1976d2',
//     }));

//     const Main = styled('main')(({ theme }) => ({
//         flexGrow: 1,
//         padding: theme.spacing(3),
//     }));

//     const menuItems = [
//         { text: 'Feed', path: 'dashboard' },
//         { text: 'Create Event', path: 'create-event' },
//         { text: 'Profile', path: 'profile' }
//     ];

//     return (
//         <Box sx={{ display: 'flex' }}>
//             <CssBaseline />

//             {/* App Bar */}
//             <AppBar position="fixed">

//                 <CustomUserAppBar />
//             </AppBar>




//             {/* Sidebar */}

//             <Drawer variant="permanent">

//                 <List>
//                     <Box sx={{
//                         display: "flex",
//                         alignItems: "center",
//                         marginLeft: {
//                             xs: 0,
//                             sm: "19px",
//                             md: "19px"

//                         },
//                         marginRight: {
//                             xs: 0,
//                             sm: "14px",
//                             md: "14px"

//                         },
//                         padding: "10px",
//                         // Apply boxShadow only on screen sizes 'sm' and up (not on mobile)
//                         boxShadow: {
//                             xs: 0, // mobile view
//                             sm: 4, // tablet and above
//                         },
//                         borderRadius: "10px"
//                     }}>
//                         <Box mr={2}>
//                             <Avatar sx={{ bgcolor: "green" }}>u</Avatar>
//                         </Box>

//                         <Box>
//                             <Typography>Preethi Sagar</Typography>
//                             <Typography>@preethi</Typography>
//                         </Box>

//                     </Box>
//                     {menuItems.map((item, index) => (
//                         <ListItem key={item.text} disablePadding sx={{ display: 'block' }}>
//                             <ListItemButton
//                                 component={Link}
//                                 to={`/website/${item.path}`}
//                                 sx={{
//                                     minHeight: 48,
//                                     justifyContent: isMobile ? 'center' : 'initial',
//                                     px: 2.5,
//                                 }}
//                             >
//                                 <ListItemIcon
//                                     sx={{
//                                         minWidth: 0,
//                                         mr: isMobile ? 0 : 3,
//                                         justifyContent: 'center',
//                                     }}
//                                 >
//                                     {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
//                                 </ListItemIcon>
//                                 {!isMobile && <ListItemText primary={item.text} />}
//                             </ListItemButton>
//                         </ListItem>
//                     ))}

//                 </List>
//             </Drawer>

//             {/* Main Content */}
//             <Grid
//                 container
//                 sx={{
//                     width: "100%",
//                 }} >
//                 {/* Main contant div or gird  */}
//                 <Grid
//                     item

//                     size={{ md: 9, xs: 12, sm: 12 }}
//                     sx={{
//                         height: { md: "100vh", xs: "90vh", sm: "90vh" }, // take full viewport height
//                         overflowY: 'auto',  // enable vertical scroll when needed
//                         width: '100%',      // full width
//                         boxSizing: 'border-box',
//                         padding: '16px',     // optional padding
//                         // border: "1px solid red"
//                         borderRight: "1px solid rgba(0, 0, 0, 0.12)"


//                     }}>
//                     {/* Main contant  */}
//                     <Outlet />
//                 </Grid>


//                 <Grid item

//                     size={{ md: 3, xs: 12, sm: 12 }}
//                     sx={{ p: 2 }}>
//                     <Typography variant="h6" gutterBottom>
//                         Post Your Event
//                     </Typography>
//                     {/* You can place your event form or content here */}
//                     <Typography>
//                         📅 Add details about your upcoming event.
//                     </Typography>
//                     <Typography variant="h6" gutterBottom>
//                         Post Your Event
//                     </Typography>
//                     {/* You can place your event form or content here */}

//                 </Grid>

//             </Grid>

//         </Box>
//     );
// }


import React, { useEffect, useState } from 'react';
import { styled, useTheme } from '@mui/material/styles';
import {
    Box,
    CssBaseline,
    Drawer as MuiDrawer,
    AppBar as MuiAppBar,
    Toolbar,
    List,
    Typography,
    IconButton,
    ListItem,
    ListItemButton,
    ListItemIcon,
    ListItemText,
    Avatar,
    Grid,
    useMediaQuery,
    Divider,
    Icon
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import { Outlet, Link } from 'react-router-dom';
// import CustomUserAppBar from '../AppBar/CustomUserAppBar';
import { StarBorderOutlined } from '@mui/icons-material';
import CustomUserAppBar from '../AppBar/CustomUserAppBar';
import SidebarUserList from '../../Pages/Website/HomeProfile/SidebarUserList';
import { useDispatch, useSelector } from 'react-redux';
import actions from '../../ReduxStore/actions';
import { BsFillPostcardHeartFill } from 'react-icons/bs';
import { IoGitPullRequestSharp } from 'react-icons/io5';
import { TbUsers, TbUsersPlus } from 'react-icons/tb';
import { adminUrl } from '../../constants';
// import SidebarUserList from '../../../Pages/Connection/SidebarUserList';
// import PostBox from '../../Pages/HomeProfile/PostBox';


export default function WebsiteSideNav() {
    const theme = useTheme();
    // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));


    const drawerWidth = isMobile ? 60 : 240;

    // Styled Drawer
    const Drawer = styled(MuiDrawer)(() => ({
        width: drawerWidth,
        flexShrink: 0,
        whiteSpace: 'nowrap',
        '& .MuiDrawer-paper': {
            width: drawerWidth,
            boxSizing: 'border-box',
            position: 'relative', // So AppBar can be on top
            zIndex: theme.zIndex.appBar - 1,
        },
    }));

    // Styled AppBar
    const AppBar = styled(MuiAppBar)(() => ({
        zIndex: theme.zIndex.drawer + 1,
        backgroundColor: '#1976d2',
        width: '100%', // Full width to overlap Drawer
    }));

    const menuItems = [
        { text: 'Feed', path: 'user', icon: BsFillPostcardHeartFill },
        { text: 'Requests', path: 'user/Connections', icon: IoGitPullRequestSharp },
        { text: 'Suggestion-Friends', path: 'user/suggestionconnections', icon: TbUsersPlus },
        { text: 'My Connections', path: 'user/myconnections', icon: TbUsers },




        // { text: 'Watch Videos', path: 'watchvideos' },
        // { text: 'Photos', path: 'photos' },
        // { text: 'Files', path: 'files' }

    ];
    // const skills = ["HTML", "CSS", "Javascript", "React js"]
    const [skills, setSkills] = useState([])
    const { updateUserStoreInfo } = useSelector(state => state?.updateUserStoreInfo);
    const sessionUserId = sessionStorage.getItem("userId")

    useEffect(() => {


        const fetchData = async () => {
            const data1 = {
                data: {},
                method: "get",
                apiName: `getUserSkills/${sessionUserId}`,
            };
            const response = await dispatch(actions.GETUSERSKILLS(data1));

            console.log(response, "responseresponse")

            if (response?.payload?.message === "getUserSkills fetched successfully.") {
                console.log("hiiiiiiiiiiiiiiii")

                // const responseData = response?.payload?.data?.map((data) => ({
                //     // user_id: data?.user_id,

                //      data,






                // }))
                setSkills(response?.payload?.data)

            }
        }
        fetchData()


    }, [updateUserStoreInfo])


    const dispatch = useDispatch()



    // const { AlumniSkillsGetById } = useSelector(
    //     (state) => state?.AlumniSkillsGetById
    // );

    // const { websitehomepageGetByToken } = useSelector(
    //     (state) => state?.websitehomepageGetByToken
    // );


    // useEffect(() => {
    //     const fetchData = async () => {

    //         const data2 = {
    //             data: {},
    //             method: "get",
    //             apiName: `websitehomepage`,
    //         };

    //         const responseDataSkills = await dispatch(actions.WEBSITEHOMEPAGEGETBYTOKEN(data2));
    //         console.log(responseDataSkills, "responseDataaa")


    //     }

    //     fetchData();

    // }, []);

    // const skills1 = websitehomepageGetByToken?.data?.skills?.map((skill) => skill?.skill);
    const { getUserById } = useSelector(state => state?.getUserById);


    // const sessionUserId = sessionStorage.getItem("userId")

    // // const dispatch = useDispatch()
    // useEffect(() => {

    //     const fetchData = async () => {
    //         const data1 = {
    //             data: {},
    //             method: "get",
    //             apiName: `getUserById/${sessionUserId}`,
    //         };
    //         const response = await dispatch(actions.GETUSERBYID(data1));


    //     }
    //     fetchData()


    // }, [])



    return (
        <Box sx={{ background: "var(--main-contentbackgroundcolor)" }}>
            {/* <CustomUserAppBar /> */}

            <Box
                sx={{
                    display: 'flex',
                    flexDirection: { xs: 'column', md: 'row' },
                    // minHeight: '100vh',
                    position: "relative",
                    background: 'var(--main-contentbackgroundcolor)',
                }}
            >

                <CssBaseline />


                <Drawer
                    variant={isMobile ? 'permanent' : 'permanent'}
                    anchor={isMobile ? 'top' : 'left'}
                    sx={{
                        width: isMobile ? '90%' : 250,
                        height: isMobile ? 60 : '300px',
                        flexShrink: 0,

                        '&.MuiDrawer-docked': {
                            // width: 240,
                            minWidth: isMobile ? 300 : 240,

                            ml: 2,
                            background: 'var(--main-contentbackgroundcolor)',
                            mt: 2,
                            mr: 2

                        },

                        '& .MuiDrawer-paper': {
                            width: isMobile ? '100%' : 250,
                            height: isMobile ? 60 : 'auto',
                            display: 'flex',
                            flexDirection: isMobile ? 'row' : 'column',
                            alignItems: isMobile ? 'center' : 'flex-start',
                            justifyContent: isMobile ? 'center' : 'flex-start',
                            boxShadow: 4,
                            background: 'white',
                            position: 'relative',
                            zIndex: theme.zIndex.drawer,
                        },
                    }}
                >

                    {/* <Toolbar />  */}
                    {/* Add space so content starts below AppBar */}
                    <List
                        sx={{
                            display: 'flex',
                            flexDirection: isMobile ? 'row' : 'column',
                            alignItems: isMobile ? 'center' : 'flex-start',
                            width: '100%',
                            p: isMobile ? 0 : 2,
                            borderBottom: !isMobile && "1px solid lightgray",

                        }}
                    >
                        {!isMobile && (

                            <Box sx={{
                                display: "flex",
                                alignItems: "center",
                                // mx: isMobile ? 0 : 2,
                                // my: 2,
                                mb: 2,
                                p: 1,
                                width: "100%",
                                boxShadow: { xs: 0, sm: 2 },
                                borderRadius: "10px"
                            }}>
                                <Avatar sx={{ bgcolor: "green", mr: 2 }} src={`${adminUrl}${getUserById?.data?.profileImage}`}></Avatar>
                                {!isMobile && (
                                    <Box>
                                        <Typography variant="subtitle2">
                                            {getUserById?.data?.first_name} {getUserById?.data?.last_name}
                                            {/* {`${websitehomepageGetByToken?.data?.user?.first_name} ${websitehomepageGetByToken?.data?.user?.last_name}`} */}
                                        </Typography>

                                        <Typography variant="caption">@{getUserById?.data?.first_name}</Typography>
                                    </Box>
                                )}
                            </Box>
                        )}

                        {menuItems.map((item) => (
                            <ListItem key={item.text} disablePadding sx={{ display: isMobile ? 'inline-flex' : 'block' }}>
                                <ListItemButton
                                    component={Link}
                                    to={`/${item.path}`}
                                    sx={{
                                        justifyContent: isMobile ? 'center' : 'flex-start',
                                        px: 2,
                                    }}
                                >
                                    <ListItemIcon
                                        sx={{
                                            justifyContent: 'center',
                                            minWidth: 0,
                                            mr: isMobile ? 1 : 2,
                                        }}
                                    >
                                        <item.icon style={{ fontSize: '20px', color: 'black' }} />
                                    </ListItemIcon>
                                    {!isMobile && (
                                        <ListItemText primary={item.text}
                                            sx={{
                                                "& .MuiListItemText-primary": {
                                                    color: "black",
                                                    fontSize: "16px",
                                                    fontWeight: "400"
                                                },
                                                color: "black"
                                            }} />
                                    )}
                                </ListItemButton>
                            </ListItem>
                        ))}
                    </List>

                    <Divider />

                    {/* <Box sx={{ display: { md: "block", xs: "none" } }}>
                        <Box sx={{ textAlign: "center" }}>
                            <Typography variant='subtitle2' sx={{ fontSize: "18px", color: "gray" }}>Profile Views</Typography>
                            <Box sx={{ display: "flex", justifyContent: "center" }}>
                                <Box mr={2}>
                                    <Typography variant='h4'
                                        sx={{
                                            fontSize: "35px",
                                            color: "var(--main-color)"
                                        }}>
                                        08</Typography>
                                    <Typography variant='body1' sx={{ fontSize: "12px", color: "gray" }}>Last 5 days</Typography>
                                </Box>
                                <Divider color="var(--main-color)" width='1px' />
                                <Box ml={2}>
                                    <Typography variant='h4' sx={{ fontSize: "35px", color: "var(--main-color)" }}>+43%</Typography>
                                    <Typography variant='body1' sx={{ fontSize: "12px", color: "gray" }}>Since Last Week</Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box> */}


                    <Box sx={{
                        display: { md: "block", xs: "none" },
                        //  mt: 2,
                        minHeight: "50vh"
                    }}>

                        <List
                            sx={{
                                padding: 2

                            }}
                        >


                            {/* Menu Items */}
                            <Typography variant="h4" sx={{ fontSize: "18px", color: "black", fontWeight: "800" }}>
                                Skills:
                            </Typography>
                            {skills?.length > 0 ? (
                                <>
                            

                                    {skills?.map((item, index) => (
                                        <ListItem key={item} disablePadding sx={{ display: 'block' }}>
                                            <ListItemButton
                                                component={Link}
                                                // to={`/${item.path}`}
                                                sx={{
                                                    minHeight: 48,
                                                    justifyContent: isMobile ? 'center' : 'initial',
                                                    px: 2.5,
                                                }}
                                            >
                                                <ListItemIcon
                                                    sx={{
                                                        minWidth: 0,
                                                        mr: isMobile ? 0 : 3,
                                                        justifyContent: 'center',
                                                    }}
                                                >
                                                    <StarBorderOutlined />
                                                </ListItemIcon>
                                                {!isMobile && <ListItemText primary={item}
                                                    sx={{
                                                        "& .MuiListItemText-primary": {
                                                            color: "black",
                                                            fontSize: "15px",
                                                            fontWeight: "400"
                                                        },
                                                        color: "black"
                                                    }} />}

                                            </ListItemButton>
                                        </ListItem>
                                    ))}

                                </>
                            ) : (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        justifyContent: 'center',
                                        alignItems: 'center',
                                        minHeight: '40vh', // or adjust as needed
                                        width: '202px',
                                    }}
                                >
                                    <Typography variant='body1'>
                                        No skills post yet!
                                    </Typography>
                                </Box>
                            )}
                        </List>
                    </Box>
                </Drawer>

                {/* Main content */}
                <Box
                    component="main"
                    sx={{
                        flexGrow: 1,
                        p: 2,
                        mt: isMobile ? 0 : 0, // Push content below the top drawer on mobile
                    }}
                >
                    {/* Your page content */}
                    <Outlet />
                </Box>

                {/* <Toolbar /> */}
                {/* Push content below AppBar */}
                {/* <Outlet /> */}
            </Box>
        </Box >
    );
}
